import React from "react";

const InputField = ({
  type,
  label,
  handleChange,
  placeholder,
  name,
  htmlFor,
  id,
  value,
  readOnly,
  ...props
}) => {
  return (
    <div className="mb-5">
      <label className="text-grey" htmlFor={htmlFor}>
        {label}
      </label>
      <input
        type={type}
        onChange={handleChange}
        placeholder={placeholder}
        name={name}
        readOnly={readOnly}
        id={id}
        {...props}
        value={value}
        className="w-full border border-sbg-light-grey-2 px-2 py-2 mt-1.5 text-grey focus:outline-none placeholder-sbg-dark-blue placeholder-opacity-10"
      />
    </div>
  );
};

export default InputField;
